import type { EitherTranslatedOrError, SimpleFormatMessage } from 'components/secondaryMarket/shared/Clipboard/types';
import { Sales } from 'state/secondaryMarket/shared/referential/referential.model';

export const translateSelectedSale = (
  pastedValue: string,
  formatSimpleMessage: SimpleFormatMessage,
  metadata?: unknown,
) => {
  const possibleValues = (metadata as Sales[] | undefined) ?? [];

  const exactMatches = possibleValues.filter(x => x.id === pastedValue || x.firstName === pastedValue);
  if (exactMatches.length === 1) {
    return { status: 'success', value: exactMatches[0] } as EitherTranslatedOrError<Sales>;
  }

  const partialMatches = possibleValues.filter(x => x.firstName?.includes(pastedValue));
  if (partialMatches.length === 1) {
    return { status: 'success', value: partialMatches[0] } as EitherTranslatedOrError<Sales>;
  }

  const error = formatSimpleMessage('moreMenu.pasteFromClipboard.error.invalidNotInTheList', { value: pastedValue });
  return { status: 'error', error } as EitherTranslatedOrError<Sales>;
};
